
///input自动获取焦点
var vfocus = {
    register:function(app){
        app.directive('focus', {
            // 当被绑定的元素挂载到 DOM 中时……
            mounted(el) {
              // 聚焦元素
              //console.log("挂拆",el)
              setTimeout(() => {
                el.select()
                el.focus()
                //console.log("获取焦点")
              }, 100);
            }
        })

        app.directive('select', {
          // 当被绑定的元素挂载到 DOM 中时……
          mounted(el) {
            // 聚焦元素
            el.addEventListener('focus', function (event) {
              el.select()
            });
          }
        })
    }
}

export default vfocus